import React from 'react';
import PropTypes from 'prop-types';

class CarouselComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            track: null,
            initialPosition: null,
            moving: false,
            transform: 0,
            slidesWidth: 0
        };
    }

    gestureStart = e => {
        const { track } = this.state;

        this.setState({ initialPosition: e.pageX });
        this.setState({ moving: true });
        const transformMatrix = window.getComputedStyle(track).getPropertyValue('transform');
        if (transformMatrix !== 'none') {
            this.setState({ transform: parseInt(transformMatrix.split(',')[4].trim(), 10) });
        }
    };

    gestureMove = e => {
        const { moving, initialPosition, transform, track, slidesWidth } = this.state;
        const { data } = this.props;

        if (slidesWidth === 0) {
            let total = 0;
            data.forEach((e, i) => {
                total += document.querySelector(`.slide-${i + 1}`).clientWidth;
            });
            this.setState({ slidesWidth: total });
        }

        if (moving) {
            const currentPosition = e.pageX;
            const diff = currentPosition - initialPosition;
            const result =
                transform + diff > 0
                    ? 0
                    : transform + diff < -(slidesWidth - track.clientWidth)
                    ? -(slidesWidth - track.clientWidth)
                    : transform + diff;
            track.style.transform = `translateX(${result}px)`;
        }
    };

    gestureEnd = e => {
        this.setState({ moving: false });
    };

    componentDidMount() {
        this.setState({ track: document.querySelector('.slides') });

        if (window.PointerEvent) {
            window.addEventListener('pointerdown', this.gestureStart);
            window.addEventListener('pointermove', this.gestureMove);
            window.addEventListener('pointerup', this.gestureEnd);
        } else {
            window.addEventListener('touchdown', this.gestureStart);
            window.addEventListener('touchmove', this.gestureMove);
            window.addEventListener('touchup', this.gestureEnd);
            window.addEventListener('mousedown', this.gestureStart);
            window.addEventListener('mousemove', this.gestureMove);
            window.addEventListener('mouseup', this.gestureEnd);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('pointerdown', this.gestureStart);
        window.removeEventListener('pointermove', this.gestureMove);
        window.removeEventListener('pointerup', this.gestureEnd);
        window.removeEventListener('touchdown', this.gestureStart);
        window.removeEventListener('touchmove', this.gestureMove);
        window.removeEventListener('touchup', this.gestureEnd);
        window.removeEventListener('mousedown', this.gestureStart);
        window.removeEventListener('mousemove', this.gestureMove);
        window.removeEventListener('mouseup', this.gestureEnd);
    }

    render() {
        const { id, cssClass, data, hideSkip } = this.props;

        return (
            <section
                id={id}
                className={`carousel ${cssClass ? cssClass : ''}`}
                aria-label="carousel"
                tabIndex="-1">
                {!hideSkip && (
                    <a className="carousel__skip-link" href="#skip-link">
                        Sauter le carousel
                    </a>
                )}
                <div className="slides">
                    {data.map((e, i) => (
                        <div
                            key={i}
                            className={`slides-item slide-${i + 1}`}
                            id={`slide-${i + 1}`}
                            aria-label={`slide ${i + 1} of ${data.length}`}
                            tabIndex="-1">
                            {e}
                        </div>
                    ))}
                </div>
            </section>
        );
    }
}

CarouselComponent.propTypes = {
    id: PropTypes.string,
    cssClass: PropTypes.string,
    data: PropTypes.array.isRequired,
    hideSkip: PropTypes.bool
};

export default CarouselComponent;



// WEBPACK FOOTER //
// ./src/components/pages/account/CarouselComponent.js